import { render, staticRenderFns } from "./XQAvatar.vue?vue&type=template&id=cae17baa&scoped=true&"
import script from "./XQAvatar.vue?vue&type=script&lang=js&"
export * from "./XQAvatar.vue?vue&type=script&lang=js&"
import style0 from "./XQAvatar.vue?vue&type=style&index=0&id=cae17baa&prod&scoped=true&lang=less&"
import style1 from "./XQAvatar.vue?vue&type=style&index=1&id=cae17baa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae17baa",
  null
  
)

export default component.exports